import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Intervento } from '../../../models/intervento.model';
import { NGXLogger } from 'ngx-logger';
import { InterventiService } from '../../../services/interventi.service';

@Component({
  selector: 'app-conferma-finanziamento',
  templateUrl: './conferma-finanziamento.component.html',
  styleUrls: ['./conferma-finanziamento.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputNumberModule,
    ToastModule
  ],
  providers: [MessageService, NGXLogger]
})
export class ConfermaFinanziamentoComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() intervento: Intervento | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() finanziato = new EventEmitter<number>();

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private logger: NGXLogger,
    private interventoService: InterventiService
  ) {}

  ngOnInit() {
   // this.logger.info(this.intervento);
    this.form = this.fb.group({
      importoFinanziato: [{ value: this.intervento?.importoRimodulato, disabled: false },[Validators.required, Validators.min(0)]],
      importoContributo: [{ value: this.intervento?.importoRimodulato, disabled: true }, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['intervento'] && this.form) {
      this.form.patchValue({
        importoFinanziato: this.intervento?.importoRimodulato,
        importoContributo: this.intervento?.importoRimodulato
      });
    }
  }

  show(intervento: Intervento): void {
    this.logger.info('[COMUNICA-CONTRIBUTO] SHOW! Intervento: ', intervento);
    this.intervento = intervento;
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  conferma() {
    if (this.form.valid && this.intervento && this.intervento.id) {
      const importo = this.form.get('importoFinanziato')!.value;
      if (importo !== null) {
        this.intervento.importoFinanziato = importo;
        this.interventoService.comunicaFinanziamento(this.intervento).subscribe(
          (response) => {
            this.finanziato.emit(importo);
            this.hide();
          }
        );
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Inserisci un importo valido'
      });
    }
  }
}
